import * as ActionType from '../coupon';
import { requestBetTypes } from './betTypes';
export function openBetSlipModal() {
    return { type: ActionType.OPEN_BETSLIP_MODAL };
}
export function closeBetSlipModal() {
    return { type: ActionType.CLOSE_BETSLIP_MODAL };
}
export function clearBetSlips() {
    return { type: ActionType.CLEAR_BETSLIPS };
}
export function deleteBetSlip(data) {
    return function (dispatch) {
        dispatch({ type: ActionType.DELETE_BETSLIP, data: data });
        return dispatch(requestBetTypes());
    };
}
export function loadBetSlips() {
    return function (dispatch) {
        dispatch({ type: ActionType.LOAD_BETSLIPS });
        return dispatch(requestBetTypes());
    };
}
function addRateCouponAction(data) {
    return function (dispatch) { return dispatch({ type: ActionType.ADD_RATE_COUPON, data: data }); };
}
export function changeBetAmount(data) {
    return function (dispatch) { return dispatch({ type: ActionType.CHANGE_BET_AMOUNT, data: data }); };
}
export function selectBetType(data) {
    return function (dispatch) { return dispatch({ type: ActionType.SELECT_BET_TYPE, data: data }); };
}
export function saveBetType(data) {
    return function (dispatch) { return dispatch({ type: ActionType.SAVE_BET_TYPE, data: data }); };
}
export function acceptChange(data) {
    return function (dispatch) {
        dispatch({ type: ActionType.ACCEPT_FACTOR_CHANGE, data: data });
        return dispatch(requestBetTypes());
    };
}
export function addRateCoupon(data) {
    return function (dispatch) {
        dispatch(addRateCouponAction(data));
        return dispatch(requestBetTypes());
    };
}



// WEBPACK FOOTER //
// ./src/actions/coupon/creators/coupon.js